module.exports = "<section class=\"widget upload_image\">\r\n    <h1 class=\"page-title\">Upload <span class=\"fw-semi-bold\">New Photo</span></h1>\r\n    <media-edit-modal media=\"vmnm\" ng-if =\"vmnm.editMediaModalShow\"></media-edit-modal>\r\n    <upload-photo-ml parent-obj =\"vmnm\"></upload-photo-ml>\r\n</section>\r\n\r\n\r\n\r\n\r\n"


//////////////////
// WEBPACK FOOTER
// ./public/development/assets/ext-modules/mediaModule/new-media/js/directive/partial/new-media.html
// module id = 275
// module chunks = 0